module.exports = __webpack_public_path__ + "img/agency-badge-light.62ecf96c.svg";